// extracted by css-extract-rspack-plugin
export default {"modal":"XqYnCv","form":"m6Hz0V","body":"GrAUyc","header":"OP78QW","reverseButton":"Q7YJl9","reverseIcon":"NMwffJ","decorator":"flc52g","amountButton":"sy3L79","actions":"Wr7J51"};